import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var DataSelectors = require("lib/selectors/DataSelectors");
var WidgetConfig = require('lib/widgets/WidgetsConfig')

var WidgetTitle = require("./helpers/WidgetTitle");

@connect(
  (state, props) => ({
    userDigests: DataSelectors.digests({ state })
  }),
  (dispatch, props) => ({
    populateData: () => {

    },
    selectWidgetDigests: (conditions) => {
      return dispatch((dispatch, getState) => {
        return DataSelectors.widgetDigests({ state: getState(), conditions });
      })
    },
  })
)

@providePopulateData()
class GoalsWidget extends React.Component {
  constructor(props) {
    super();
    autobind(this);
  }
  // handles expansion of component
  onClick(item) {
    console.log(item)
    // show appropriate component based on widget item
  }

  renderWidgetItems() {
    var { user, currentWidgetDigests, periodWidgetDigests, yearlyWidgetDigests, userDigests } = this.props

    switch (user.role) {
      case WidgetConfig.STUDENT_ROLE:
        var userDigest = _.findWhere(userDigests, { student_id: user.id })
        return WidgetConfig.renderStudentGoalWidgetItems(user, userDigest, this.props.showEmptyState)
      case WidgetConfig.TEACHER_ROLE:
        return WidgetConfig.renderTeacherGoalWidgetItems(user, userDigests, this.props.showEmptyState)
      default:
        return WidgetConfig.renderAdminGoalWidgetItems(user, currentWidgetDigests, this.props.showEmptyState)
    }
  }

  renderWidgetTitle() {
    return WidgetConfig.renderWidgetTitle(WidgetConfig.GOALS_WIDGET)
  }

  render() {
    var widgetItems = this.renderWidgetItems()
    if (widgetItems) {
      return (
        <div className="widgetItemsContainer goalsWidget">
          {this.renderWidgetTitle()}
          {widgetItems}
        </div>
      )
    } else {
      return null
    }
  }
};

GoalsWidget.WrappedComponent.propTypes = PageStrictPropTypes({
  // @connect handlers
  populateData: PropTypes.func,
  selectWidgetDigests: PropTypes.func,
  fetchUserDigests: PropTypes.func,

  user: PropTypes.object,
  periodWidgetDigests: PropTypes.array,
  currentWidgetDigests: PropTypes.array,
  compWidgetDigests: PropTypes.array,
  yearlyWidgetDigests: PropTypes.array,
  userDigests: PropTypes.array,
  compSize: PropTypes.number,
  compScope: PropTypes.string,
  showEmptyState: PropTypes.bool,
});

module.exports = GoalsWidget;


// WEBPACK FOOTER //
// ./modules/components/data/widgets/GoalsWidget.js